import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { FiChevronRight } from 'react-icons/fi'
import apiInstance from '../../../../../Utils/api'
import BranchButton from '../../branch/shared/BranchButton'
import BranchImageUploader from '../../branch/shared/BranchImageUploader'
import BranchSelect from '../../branch/shared/BranchSelect'
import '../../branch/branch.css'
import '../testimonial.css'

export default function TestimonialCreate() {
  const navigate = useNavigate()
  const [clientName, setClientName] = useState('')
  const [clientTitle, setClientTitle] = useState('')
  const [reviewText, setReviewText] = useState('')
  const [videoUrl, setVideoUrl] = useState('')
  const [category, setCategory] = useState('customer')
  const [images, setImages] = useState([])
  const [loading, setLoading] = useState(false)

  const create = async () => {
    if (!clientName) {
      Swal.fire({ title: 'Client name is required!', icon: 'error', showConfirmButton: false, timer: 2000 })
      return
    }
    if (!reviewText) {
      Swal.fire({ title: 'Review text is required!', icon: 'error', showConfirmButton: false, timer: 2000 })
      return
    }
    setLoading(true)
    const formData = new FormData()
    formData.append('clientName', clientName)
    if (clientTitle) formData.append('clientTitle', clientTitle)
    formData.append('reviewText', reviewText)
    if (videoUrl) formData.append('videoUrl', videoUrl)
    formData.append('category', category)
    if (images[0]) formData.append('clientImage', images[0])

    try {
      await apiInstance.post('testimonial', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      Swal.fire({ title: 'Successful!', text: 'Testimonial created successfully!', icon: 'success', showConfirmButton: false, timer: 1500 })
      navigate('/testimonial')
    } catch (err) {
      setLoading(false)
      Swal.fire({
        title: 'Something Wrong!',
        text: err.response?.data?.message || 'Try again, Please.',
        icon: 'warning',
        showConfirmButton: false,
        timer: 2000
      })
    }
  }

  return (
    <div className='branch-page'>
      <div className='branch-breadcrumb'>
        <Link to='/testimonial'>Testimonials</Link>
        <FiChevronRight className='separator' size={14} />
        <span className='current'>Create Testimonial</span>
      </div>
      <div className='branch-page-title'>Create Testimonial</div>
      <div className='branch-page-subtitle'>Add a new client testimonial</div>

      <div className='branch-card'>
        <div className='branch-card-body'>
          <div className='branch-form-grid'>
            <div>
              <div className='branch-form-section'>
                <div className='branch-form-section-title'>Client Information</div>
                <div className='branch-field'>
                  <label className='branch-field-label'>Client Name <span className='required'>*</span></label>
                  <input type='text' className='branch-input' placeholder='Full name' value={clientName} onChange={(e) => setClientName(e.target.value)} />
                </div>
                <div className='branch-field'>
                  <label className='branch-field-label'>Client Title</label>
                  <input type='text' className='branch-input' placeholder='e.g. Verified Patient' value={clientTitle} onChange={(e) => setClientTitle(e.target.value)} />
                </div>
                <div className='branch-field'>
                  <label className='branch-field-label'>Review Text <span className='required'>*</span></label>
                  <textarea className='branch-input' rows={5} placeholder='Write testimonial...' value={reviewText} onChange={(e) => setReviewText(e.target.value)} />
                </div>
                <div className='branch-field'>
                  <label className='branch-field-label'>Category</label>
                  <BranchSelect
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                    options={[
                      { value: 'customer', label: 'Customer' },
                      { value: 'celebrity', label: 'Celebrity' }
                    ]}
                    width='100%'
                  />
                </div>
              </div>
            </div>
            <div>
              <div className='branch-form-section'>
                <div className='branch-form-section-title'>Media</div>
                <div className='branch-field'>
                  <label className='branch-field-label'>Video URL</label>
                  <input type='text' className='branch-input' placeholder='YouTube or Vimeo link' value={videoUrl} onChange={(e) => setVideoUrl(e.target.value)} />
                </div>
                <div className='branch-field'>
                  <label className='branch-field-label'>Client Photo</label>
                  <BranchImageUploader
                    files={images}
                    onAdd={(newFiles) => setImages(newFiles)}
                    onRemove={(idx) => setImages(prev => prev.filter((_, i) => i !== idx))}
                    multiple={false}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='branch-form-footer'>
            <BranchButton variant='outline' to='/testimonial'>Cancel</BranchButton>
            <BranchButton onClick={create} loading={loading}>Save Changes</BranchButton>
          </div>
        </div>
      </div>
    </div>
  )
}
